import { AppText } from '@otomoro/components/shared/AppText'
import { PortableTextObject } from 'sanity'
import { goalsClasses, GoalsVariants } from './Goals.css'
import { SectionHeader } from '@otomoro/components/shared/SectionHeader'
import { PortableText, PortableTextComponents } from 'next-sanity'

interface GoalsProps extends GoalsVariants {
	tag?: string
	title: PortableTextObject
	description?: PortableTextObject
	goals: {
		title: string
		icon: {
			title: string
			svg: string
		}
	}[]
}

export const Goals: React.FC<GoalsProps> = ({ tag, title, description, goals }) => {
	const { wrapper, base, goalsGrid, goalCell, headlineWrapper, icon } = goalsClasses()

	const descComponents = {
		block: {
			normal: ({ children }: any) => (
				<AppText
					as="p"
					size="base"
					className="max-w-[34rem] mt-2 lg:mt-[24rem] xl:mt-0"
					color="black"
				>
					{children}
				</AppText>
			),
		},
		marks: {
			highlight: ({ children }: any) => <span className="text-mainPink">{children}</span>,
		},
	} as PortableTextComponents

	return (
		<div className={wrapper()}>
			<section className={base()}>
				<div className={headlineWrapper()}>
					<SectionHeader tag={tag} title={title} theme="light" noPx />
					<PortableText value={description as any} components={descComponents} />
				</div>

				<div className={goalsGrid()}>
					{goals &&
						goals.map((goal, index) => (
							<div key={`goal-${index}`} className={goalCell()}>
								<span className={icon()} dangerouslySetInnerHTML={{ __html: goal.icon.svg }} />
								<AppText
									as="strong"
									family="condensed"
									textTransform="uppercase"
									size="h3"
									weight="bold"
									className="whitespace-pre-line"
								>
									{goal.title}
								</AppText>
							</div>
						))}
				</div>
			</section>
		</div>
	)
}
